/* global _TL_ */
import ko from 'knockout';
import { formatCost } from '@bingads-webui-campaign-legacy/budget/shared/currencyFormatter';
import decimal from '@bingads-webui-component-legacy/humanize/decimal';

export default class ViewModel {
  constructor(i18n, suggestedBid, bidHintKey, suggestedClicks, impressionsMore, newI18n) {
    this.i18n = i18n;
    this.newI18n = newI18n;
    this.suggestedBid = ko.observable(decimal.fromLocalToFloat(suggestedBid));
    this.bidHintKey  = ko.observable(bidHintKey);
    this.click = ko.observable(suggestedClicks);
    this.imporessionMore = ko.observable(impressionsMore);
    this.bidSuggestion = ko.computed(() => {
      return this.i18n.get('Creation_Workflow_Bid_Suggestion_Action', {
        bid: formatCost(this.suggestedBid()),
      });
    }, this);
    this.applyBtnText = ko.computed(() => {
      return newI18n.getString(_TL_('Apply'));
    }, this);
    this.lowBidBtnTitle = ko.computed(() => {
      return newI18n.getString(_TL_('Recommended ad group bid'));
    }, this);
    this.normalBidSuggestion = ko.computed(() => {
      return newI18n.getString(_TL_('The recommended bid is {{suggestedBid}}. You could get {{imporessionMore}} more impressions and {{click}} more clicks if you apply.'),
        {
          suggestedBid: this.suggestedBid(),
          imporessionMore: parseInt(this.imporessionMore()),
          click: parseInt(this.click()),
        }
      );
    }, this);
  }
}
